
export default {
    ISNETURE:false,
    Theme:0,
    BaseUrl:`${window.self.location.href.startsWith("https")?'https':'http'}://kingsunsmart.com`
}
export const BaseUrl=`${window.self.location.href.startsWith("https")?'https':'http'}://kingsunsmart.com`